import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseAnpPricesProps<T> = {
  filters?: {
    report_id?: string;
    product_id?: string;
    geo_type?: string;
    geo_city_id?: string;
    geo_state_id?: string;
    geo_region_id?: string;
    page?: number;
  };
  mapper?: (data: any) => T,
};

export const useAnpPrices = <T,>({
  filters: { report_id, product_id, geo_type, geo_city_id, geo_state_id, geo_region_id, page } = {},
  mapper = Mapper.default<T>(),
}: UseAnpPricesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    enabled: !!report_id,
    queryKey: ['anpPrices', report_id, product_id, geo_type, geo_city_id, geo_state_id, geo_region_id, page],
    queryFn: () => {
      return privateAxios.get(`/anp/prices`, {
        params: {
          'q[report_id_eq]': report_id,
          'q[product_id_eq]': product_id,
          'q[geo_type_eq]': geo_type,
          'q[geo_city_id_eq]': geo_city_id,
          'q[geo_state_id_eq]': geo_state_id,
          'q[geo_region_id_eq]': geo_region_id,
          page,
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
